import React from 'react';
import FadeIn from './FadeIn';

import bgRise from '../assets/images/IMG_0779.JPG';
import bgLocally from '../assets/images/IMG_0795.JPG';
import bgGlobally from '../assets/images/IMG_1421.JPG';
import av1 from '../assets/images/IMG_0461.JPG';
import av2 from '../assets/images/IMG_0469.JPG';
import av3 from '../assets/images/IMG_0476.JPG';
import av4 from '../assets/images/IMG_0488.JPG';

const avatars = [av1, av2, av3, av4];

export default function Features() {
  return (
    <section className="features">
      <div className="container">
        <FadeIn>
          <div className="features__grid">
            <article className="feature-card feature-card--speakers">
              <div className="feature-card__bg" style={{ backgroundImage: `url(${bgRise})` }} />
              <h3 className="feature-card__title">Rise</h3>
              <div className="feature-card__middle">
                <div className="feature-card__icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 19V5" /><path d="M5 12l7-7 7 7" />
                  </svg>
                </div>
                <p className="feature-card__text">
                  Build from where you are. Cameroon has world-class talent —
                  LLC 2026 gives it the platform, the visibility, and the network
                  to compete globally.
                </p>
              </div>
              <div className="feature-card__bottom">
                <div className="feature-card__avatars" aria-label="Community attendees">
                  {avatars.map((src, index) => (
                    <div key={index} className={`feature-card__avatar feature-card__avatar--${index + 1}`}>
                      <img src={src} alt="" />
                    </div>
                  ))}
                </div>
                <button className="feature-card__pill">
                  Join us
                  <span>↗</span>
                </button>
              </div>
            </article>

            <article className="feature-card feature-card--technologies">
              <div className="feature-card__bg" style={{ backgroundImage: `url(${bgLocally})` }} />
              <h3 className="feature-card__title">Locally</h3>
              <p className="feature-card__text">
                Rooted in Cameroonian identity. LLC 2026 is built by and for
                Cameroonians — celebrating local excellence across 3 cities,
                5 universities, and 500+ professionals.
              </p>
            </article>

            <article className="feature-card feature-card--networking">
              <div className="feature-card__bg feature-card__bg--light" style={{ backgroundImage: `url(${bgGlobally})` }} />
              <h3 className="feature-card__title">Lead Globally</h3>
              <p className="feature-card__text">
                Compete and win at the highest level. Connect with the LinkedIn
                ecosystem, global recruiters, and international partners who are
                actively looking for Cameroonian talent.
              </p>
            </article>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
